import $ from 'jquery';

// VARIABLES
var currentSlideNumber = 0;
var totalSlideNumber = $('.h-background-product').length;

// SLIDE MOTION
function nextItem() {
  var $previousSlide = $('.h-background-product').eq(currentSlideNumber - 1);
  $previousSlide.removeClass('h-left--scroll').addClass('h-right--scroll');
}

function previousItem() {
  var $currentSlide = $('.h-background-product').eq(currentSlideNumber);
  $currentSlide.removeClass('h-right--scroll').addClass('h-left--scroll');
}

// NAVIGATION
$('.js-product__right').on('click', function(){
  if (currentSlideNumber !== totalSlideNumber - 1) {
    currentSlideNumber++;
    nextItem();
  }
});

$('.js-product__left').on('click', function(){
  if (currentSlideNumber !== 0) {
    currentSlideNumber--;
    previousItem();
  }
});
